import { useNavigate } from 'react-router-dom';
import { RegistrationScreen } from '@/components/utils/RegistrationScreen';
import * as P from '@/constants/paths';

export const ResetPasswordSuccess = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate(P.LOGIN_PATH);
  };

  return (
    <RegistrationScreen
      title="Your password has been reset"
      description="Log in with your new password"
      content={<div className="mt-8" data-testid="resetPasswordSuccess-content" />}
      actionContainerClassName="w-[361px] mx-auto"
      primaryActionLabel="Login"
      primaryActionOnClick={handleLogin}
      hideBackButton
      data-testid="resetPasswordSuccess-screen"
    />
  );
};
